import Breadcrumbs from '@storeblocks/breadcrumbs';
import { type FC } from 'react';

import { useOrganizationCmId } from '@/api/userSettings/hooks/useOrganizationCmId';
import { AnnouncementWarning } from '@/components/AnnouncementWarning';
import { CenteredPageContent } from '@/components/CenteredPageContent';
import { InternalLink } from '@/components/InternalLink';
import { PageHeading } from '@/components/PageHeading';
import { useTexts } from '@/hooks/useTexts';

import { UserSettingsForm } from './UserSettingsForm';

/**
 * Page for the user to update their settings.
 */
export const UpdateInformationPage: FC = () => {
  const organizationCmId = useOrganizationCmId();

  const texts = useTexts();

  return (
    <CenteredPageContent data-test="user-settings-page">
      <AnnouncementWarning />

      <Breadcrumbs expandAllAriaLabel={texts.breadcrumbs.expandAllAriaLabel}>
        <InternalLink to={`/${organizationCmId}`}>
          {texts.menu.links.home}
        </InternalLink>
        <InternalLink to={`/${organizationCmId}/user-settings`}>
          {texts.menu.links.profileAndLanguage}
        </InternalLink>
      </Breadcrumbs>

      <PageHeading
        header={texts.pages.userSettings.title}
        ingress={texts.pages.userSettings.description}
      />

      <UserSettingsForm />
    </CenteredPageContent>
  );
};
